<template>
  <section class="evento-lux">

    <!-- ===== CARD 1: CEREMONY ===== -->
    <article ref="card1" class="card" aria-label="Ceremony">
      <img class="icono" src="@/assets/9.avif" alt="" />
      <h3 class="titulo-script">Ceremony</h3>
      <p class="hora">6:30 PM</p>
      <p class="lugar">Saint Patrick Catholic Church 
</p>
      <p class="direccion">
   555 E Del Mar Blvd   <br>Laredo, Texas.
      
      </p>

      <a
        ref="btn1"
        class="btn-rosa"
        href="https://maps.app.goo.gl/5gNdoCH7MDWJAG5z6"
        target="_blank"
        rel="noopener"
      >
        How to get there?
        <span class="sheen"></span>
      </a>
    </article>

    <!-- ===== CARD 2: RECEPTION ===== -->
    <article ref="card2" class="card" aria-label="Reception">
      <img class="icono2" src="@/assets/botas.png" alt="" />
      <h3 class="titulo-script">Reception</h3>
      <p class="hora">8:00 PM</p>
      <p class="lugar">The Barn Reception Hall </p>
        <p class="direccion">
   4653 Casa Blanca Rd   <br>Laredo, Texas.
      
      </p>

      <a
        ref="btn2"
        class="btn-rosa"
        href="https://maps.app.goo.gl/VvjjFm7LwQgKFxqC9"
        target="_blank"
        rel="noopener"
      >
        How to get there?
        <span class="sheen"></span>
      </a>
    </article>

  </section>
</template>
<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {

    const card1 = ref(null)
    const card2 = ref(null)
    const btn1 = ref(null)
    const btn2 = ref(null)

    const animCard = (cardEl, btnEl) => {

      const $ = gsap.utils.selector(cardEl)
      const icono  = $('.icono')
      const titulo = $('.titulo-script')
      const hora   = $('.hora')
      const lugar  = $('.lugar')
      const dir    = $('.direccion')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power2.out' }
      })

      tl.from(cardEl, { opacity: 0, y: 40, duration: 0.6 })
        .from(icono,  { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
        .from(titulo, { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
        .from(hora,   { opacity: 0, x: -20, duration: 0.4 }, '-=0.3')
        .from(lugar,  { opacity: 0, x: 20, duration: 0.4 }, '-=0.4')
        .from(dir,    { opacity: 0, y: 20, duration: 0.4 }, '-=0.3')
        .from(btnEl,  { opacity: 0, scale: 0.95, duration: 0.4 }, '-=0.3')

      // brillo botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 0.8, ease: 'power2.out' }
          )
        }
      })
    }

    onMounted(() => {
      animCard(card1.value, btn1.value)
      animCard(card2.value, btn2.value)
    })

    return { card1, card2, btn1, btn2 }
  }
}
</script>

<style scoped>
/* ==================== ssssssssBASE ELEGANTE ==================== */
:root{
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux{
  min-height: 100%;
  padding: 28px 18px 4px;
  background:
    radial-gradient(1200px 600px at 50% -10%, rgba(255,255,255,.92), rgba(255,255,255,.98)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.6" fill="%23f1f1f1"/></svg>') repeat;
  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card{
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;
  padding: 24px 20px 28px;
  text-align: center;
}

/* Icono discreto */
.icono{
  width: 52px; height:auto; display:block; margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .92;
}
.icono2{
  width: 72px; height:auto; display:block; margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .99;
}

/* Tipos (usa tus fuentes ya cargadas) */
.titulo-script{
  font-family: 'britishgruesa', cursive;
  font-weight: 400;
  font-size: 56px;
  color: var(--tinta);
  letter-spacing: .4px;
  margin: 4px 0 8px;
}
.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 6px;
}
.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
}
.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 90%;
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 14px;
  background: #f5c9e6;
  color: #1f1f1f;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  box-shadow: 0 8px 16px rgba(0,0,0,.12), inset 0 1px 0 rgba(255,255,255,.7);
  transition: transform .16s ease, box-shadow .16s ease, filter .16s ease;
  border: 1px solid rgba(0,0,0,.06);
  z-index: 0;
}
.btn-rosa:hover{
  transform: translateY(-1px);
  box-shadow: 0 12px 20px rgba(0,0,0,.16), inset 0 1px 0 rgba(255,255,255,.8);
  filter: brightness(1.03);
}
.btn-rosa .sheen{
  position: absolute; top: -30%; left: -30%;
  width: 60%; height: 160%; transform: rotate(20deg);
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.55) 50%, rgba(255,255,255,0) 100%);
  pointer-events: none; mix-blend-mode: screen; opacity: 0;
}

/* ==================== LÍNEA VERTICAL ==================== */
.linea-wrapper{ height: 64px; display:flex; justify-content:center; align-items:flex-start; margin-top: 12px; }
.linea{
  width: 1px; height: 64px;
  background: linear-gradient(to bottom, #171717, #2a2929);
  transform: scaleY(1);
  will-change: transform;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px){
  .titulo-script{ font-size: 32px; }
  .hora{ font-size: 22px; }
  .lugar{ font-size: 16px; }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce){
  *{ transition: none !important; animation: none !important; }
}








/* ===== Escena final (degradado + flores) ===== */
.lux-escena-final{
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 8px;  
  margin-bottom: -30px;          /* pequeño respiro respecto a la tarjeta */
  overflow: visible;
}

.lux-degradado{
  width: 100%;
  height: 180px;              /* ajusta la altura del degradado a tu gusto */
  background: linear-gradient(
    to top,
    #f6d5e5 0%,               /* rosa baby base */
    rgba(246,213,229,0.85) 35%,
    rgba(246,213,229,0.35) 65%,
    rgba(246,213,229,0) 100%
  );
}

/* Flores pegadas al borde inferior con ligera sombra */
.lux-flores{
  position: absolute;
  bottom: -2px;               /* -2 para tocar el límite inferior visualmente */
  left: 50%;
  transform: translateX(-50%);
  width: min(760px, 110%);    /* ancho generoso estilo portada */
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0,0,0,.08));
  opacity: 0.98;
}

</style>
